<template>
  <BForm
    class="formulario"
    @submit.prevent="gravar">
    <InputBasico
      ref="inputCliente"
      type="text"
      label="Nome do cliente"
      name="inputCliente"
      v-model="form.cliente"
      v-validate="'required|min:3'"
      :errorsBag="errors"
    />

    <InputCheckServicos
      label="Opções"
      v-model="form.servicos"
      name="inputServicos"
    />

    <div class="total">
      <span class="total__label">Total: {{ totalServico | currency }}</span>
    </div>

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Salvar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputCheckServicos from '@/modules/administrativo/components/inputs/InputCheckServicos.vue'

export default {
  name: 'LancamentoServicoCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputCheckServicos,
    InputBasico,
  },
  props: {
    usuario: {
      required: true,
    },
  },
  mounted() {
    this.$refs.inputCliente.focar()
  },
  computed: {
    totalServico: function () {
      if (this.form.servicos.length > 0) {
        let total = 0
        this.form.servicos.forEach(item => {
          total += item.preco
        })

        return total
      }

      return 0
    },
  },
  watch: {
    totalServico: function (val) {
      this.form.somatorioServicos = val
      this.form.total = val
    },
  },
  methods: {
    valoresIniciaisForm() {
      return {
        funcionario: this.usuario,
        cliente: '',
        servicos: [],
        somatorioServicos: 0,
        total: 0,
      }
    },
    retornaCamposGravar() {
      return this.form
    },
  },
}

</script>

<style lang="scss" scoped>

.formulario {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

.total {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin: 0.5rem 0;

  &__label {
    font-size: 1.5rem;
    font-weight: 500;
  }
}

</style>
